import classNames from "classnames"
import { Link } from "react-router-dom"

import "./Button.scss"

type ButtonProps = {
  text?: string
  style?: "primary" | "outline" | "primary outline"
  className?: string
  size?: "small" | "medium"
  linkTo?: string | null
} & React.ButtonHTMLAttributes<HTMLButtonElement> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

function Button(props: ButtonProps) {
  const {
    text = "Button",
    style = "",
    className,
    size = "medium",
    linkTo = null,
    ...rest
  } = props

  const usedClassName = classNames("Button", style, className, {
    "Button--small": size === "small",
    "Button--medium": size === "medium",
  })

  if (linkTo) {
    return (
      <Link className={usedClassName} to={linkTo} {...rest}>
        {text}
      </Link>
    )
  }

  return (
    <button className={usedClassName} {...rest}>
      {text}
    </button>
  )
}

export default Button
